import { render } from "./Guides.vue?vue&type=template&id=662eec0e"
import script from "./Guides.vue?vue&type=script&lang=js"
export * from "./Guides.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "662eec0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('662eec0e', script)) {
    api.reload('662eec0e', script)
  }
  
  module.hot.accept("./Guides.vue?vue&type=template&id=662eec0e", () => {
    api.rerender('662eec0e', render)
  })

}

script.__file = "src/views/support/modules/Guides.vue"

export default script